import { useAppI18n } from "@/i18n/useAppI18n";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useI18n = () => {
  return useAppI18n("admin-console");
};
